import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { PagePropsType, regroupModuleReducers } from '@rakutenfrance/redux-apollo-helper';

import { renderReact } from '../../fragmentHelper/renderReactCustom';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import '@rakutenfrance/crew-partner-modal/build/style.global.css';
import CrewPartnerModal from '@rakutenfrance/crew-partner-modal';
import { GetServerSideProps, GetServerSidePropsHypernovaWatchContext } from '../../types';
import { configService as configurationService } from '@rakutenfrance/config-service';

export const serverCanCache = true;

const { CrewPartnerModalContainer } = CrewPartnerModal.containers;

// @ts-ignore
const reducers = regroupModuleReducers([CrewPartnerModal]);

const ClientWrapperContainer = ({ advertCrewModale }): JSX.Element => {
  const [renderOnClient, setRenderOnClient] = useState(false);
  useEffect(() => {
    setRenderOnClient(true);
  }, []);
  return <div>{renderOnClient && <CrewPartnerModalContainer {...advertCrewModale} />}</div>;
};

const WrappedCrewPartnerModal: React.FC<PagePropsType & { graphQlvariables: any; advertCrewModale: any }> = ({
  initialApolloState,
  initialReduxState,
  moduleName,
  advertCrewModale,
}) => {

  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      moduleName={moduleName}
      reducers={reducers}
    >
      <ClientWrapperContainer advertCrewModale={advertCrewModale} />
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const renderFunction = renderReact('CrewPartnerModal', WrappedCrewPartnerModal);

export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext): Promise<GetServerSideProps> => {
  const advertCrewModale = configurationService.get().advertCrewModale;
  return {
    props: {
      advertCrewModale,
    },
  };
};
